import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import Sidebar from "../../../../partials/aside/Sidebar";
import TitleBar from "../../../../partials/content/TitleBar";
import helperSpinner from "../../../../../helpers/spinner";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumber from "../../../../../helpers/numbers";
import helpersTime from "../../../../../helpers/time";

export default function View() {
  const params = useParams();
  const noteCallID = params.noteCallID;
  const [noteCall, setNoteCall] = useState();
  const userID = params.userID;

  useEffect(() => {
    getNoteCall();
  }, []);

  const getNoteCall = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestAddNoteCall = await sendRequestGetNoteCall(
      noteCallID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestAddNoteCall) {
      return;
    }
    setNoteCall(resultSendRequestAddNoteCall);
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetNoteCall = async (noteCallID) => {
    const headersRequest = getHeaderRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/user/note-call/" + noteCallID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return result.data.data;
  };

  const generateTable = () => {
    return (
      <div className="table-responsive pt-2">
        <table className="table table-hilite tbl-td-white-space m-0">
          <thead>
            <tr>
              <td
                colSpan={2}
                className="text-center"
                style={{ borderRadius: "25px 25px 0 0" }}
              >
                اطلاعات یادادشت تماس با کاربر
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>عنوان</td>
              <td>{noteCall.unc_title}</td>
            </tr>
            <tr>
              <td>متن</td>
              <td>{noteCall.unc_text}</td>
            </tr>
            <tr>
              <td>شماره کاربر مکالمه کننده</td>
              <td>{noteCall.unc_caller_user_id}</td>
            </tr>
            <tr>
              <td>کاربر مکالمه کننده</td>
              <td>{noteCall.caller_user}</td>
            </tr>
            <tr>
              <td>تاریخ درج</td>
              <td>
                {helpersNumber.toPersianNum(
                  helpersTime.convertGregorianToJalali(
                    noteCall.unc_created_at
                  ) +
                    " " +
                    noteCall.unc_created_at.split(" ")[1]
                )}{" "}
              </td>
            </tr>
            <tr>
              <td>تاریخ آخرین ویرایش</td>
              <td>
                {helpersNumber.toPersianNum(
                  helpersTime.convertGregorianToJalali(
                    noteCall.unc_updated_at
                  ) +
                    " " +
                    noteCall.unc_updated_at.split(" ")[1]
                )}{" "}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اضافه کردن یادادشت تماس با کاربر" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  to={`/user/manage/${userID}/note-call`}
                  className="btn btn-primary"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i class="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              {noteCall && generateTable()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
